const ComponentBase=require('../../base/ComponentBase');
const g2 = require('../../g2');
/**
 * @constructor
 * @classdesc 台风警戒线
 * @augments G.base.ComponentBase
 * @alias G.biz.TyphoonWarningLine
 * @param {Object} options - 必填，构造参数；
 * @param {G.Map} options.map - 必填，地图对象
 * @param {Integer} [options.SpatialReference] - 非必填，坐标系srid
 * @param {Object} options.warningLineParm - 必填，预警线配置对象
 * @param {String} options.warningLineParm.id - 必填，id
 * @param {String} options.warningLineParm.name - 必填，name
 * @param {Integer} options.warningLineParm.zIndex - 必填，zindex
 * @param {Float[]} options.warningLineParm.pic24_xy - 必填，24小时警戒图片位置
 * @param {Float[]} options.warningLineParm.pic48_xy - 必填，48小时警戒图片位置
 * @param {Integer} options.warningLineParm.lineStyle48h - 24小时警戒线样式 实线
 * @param {Integer} options.warningLineParm.lineStyle24h - 24小时警戒线样式 虚线
 * @param {Array.<Float[]>} options.warningLineParm.points_24h - 24小时警戒线 点集
 * @param {Array.<Float[]>} options.warningLineParm.points_48h - 48小时警戒线 点集
 * @param {String} options.warningLineParm.color_24h - 24小时警戒线颜色
 * @param {String} options.warningLineParm.color_48h - 48小时警戒线颜色
 * @param {String} options.warningLineParm.pic_base24 - 24小时图片，base64编码
 * @param {String} options.warningLineParm.pic_base48 - 48小时图片，base64编码
 * @example
 * //加载组件
 * var typhoonWariningLine = new G.biz.TyphoonWarningLine({
 *     map:demo.emap,
 *     warningLineParm:{ 
 *          id: 'typhoon_alertline',
 *          name: '台风警戒线',
 *          zIndex:100,
 *          pic24_xy:[127,30],
 *          pic48_xy:[132,30],
 *          lineStyle48h:3,
 *          lineStyle24h:5,
 *          points_24h:[[126.993568, 34.005024], [126.993568 ,21.971252 ], [118.995521,17.96586], [118.995521,10.97105], ...],
 *          points_48h:[[131.981361, 33.959474], [131.981361 ,14.96886 ], [119.962318,-0.035506], [104.998939,-0.035506]],
 *          color_24h: '#FFFF00',
 *          color_48h: '#160DFF',
 *          pic_base24:'data:image/png;base64,XXX',
 *          pic_base48:'data:image/png;base64,XXX'
 *     }
 *     });
 * //销毁组件
 * typhoonWariningLine.destroy();
*/
let component = ComponentBase.extend({
    options: {
        map:null,
        warningLineParm:null
    },
    initialize: function (options) {
        ComponentBase.prototype.initialize.call(this, options);

        if (this.enable==true){return};
        this.dataSpatialReference=4326;//4326
        this.dataSpatialReference=this._mergeOptions(this.dataSpatialReference,options.dataSpatialReference);
        this.map =options.map;
        //默认台风预警线配置
        var warning_line_parm={
            id: 'typhoon_alertline',
            name: "台风警戒线",
            zIndex:100,
            pic24_xy:[127,30],// 24小时警戒图片位置
            pic48_xy:[132,30],//48小时警戒图片位置
            lineStyle48h:3,//24小时警戒线样式 实线
            lineStyle24h:5,//24小时警戒线样式 虚线
            points_24h:[[126.993568, 34.005024], [126.993568 ,21.971252 ], [118.995521,17.96586], [118.995521,10.97105], [113.018959,4.48627], [104.998939,-0.035506]],
            points_48h:[[131.981361, 33.959474], [131.981361 ,14.96886 ], [119.962318,-0.035506], [104.998939,-0.035506]],
            color_24h : '#FFFF00', //{r: 255, g: 255, b: 0}, //24小时警戒线颜色
            color_48h : '#160DFF', // {r: 255, g: 255, b: 0},
            pic_base24:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAByCAYAAABA87G+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAACPElEQVRoge2aQW7EIAxFIaqUG4y67KrqEXr/4/QCo9kMXcxEIdQ23zaJwpS/adJkeBgMNpCYUgpHajqUNoCnBaY0pZQmyPveagXl9zHeo6diIQgWLrAY73EBUVagllWBiLQwEZhbJsG0zQxZaC3cBKRgngpEaS6VCub6r1YJFljCEDhiMdSkkjfmzxCvFZt0D/U5lw5gP0BN3GsCbKEBZPvN2p9mC6W0wwysRQELFEqipAK0UBLYMqUoRealWpDm/fMNi+6B4tpikXfCzjVymn8OtESMcwwLqtat5lVyWOSTt6bJkEpBA58rzBJVzuWlZXPunpeWTWXNY2DgHoKdZpF3eKj6sIVUfdhC1SSqNVTdhyH4mnpE/BcHPubO97Ref6XtM73zVDf3VIV5NvfWH1+y68/Nc8t4dVmYZwQoUFgffj/vLs+/y/0M7aFyEqe2R4E/TIVWCzVgcWqj9rnL/6sXr1LWphUCP3wuVZ09cdI06+tbCAVgrkCLc401/gCq1SRNPGx9aFlNmSykoPD7XUQLz44xkCZOqbz2yD0stBWBNoa257wfLivhY3Vps6jffRpOZdam6UfTyYz27D6X6DRU/sl9wYAKHvhcIsxV0A1spT68tCsglAjTTjKHEG6Bei7pPBGfm0c5qBtY100cm5zgFONvlJhDjFd1xK9uX1JWeCK/yUupykjvbd5BPzOjACikCqx9JLeMwxiv6o0hV5pYVgTR4RG/Og5rXto04kug3SO+pBHxB3AAXfoFW1EPwh6Vf8EAAAAASUVORK5CYII=',
            pic_base48:'data:image/png;base64,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'
        };
        this.warning_line_parm=warning_line_parm;
        //预警线配置合并
        this.warning_line_parm= this._mergeOptions(this.warning_line_parm,options.warningLineParm);

        this.warnLinelayer = new g2.carto.ElementLayer({
            id:  this.warning_line_parm.id,// 'typhoon_alertline',
            name: this.warning_line_parm.name,// "台风警戒线",
            zIndex:this.warning_line_parm.zIndex,
            map: this.map
        });
        this.warnLinelayer._typeLayer="typhoon";//非底图

        this.enable=true;        
    },
    /**
     * 组件加载
     * @method
     * @memberOf G.biz.TyphoonWarningLine
     */
    load() {
        ComponentBase.prototype.load.call(this);
        this.map.addLayer(this.warnLinelayer);
        this.warnLine(); 
    },
    destroy: function () {  
        this.unload();
        this.warning_line_parm=undefined;
        this.enable=false;
        ComponentBase.prototype.destroy.call(this);
    },

    //获取有效数据新值
    getValidDataValue:function(oldDataValue,newDataVaule){
        if (newDataVaule!=undefined){
            oldDataValue=newDataVaule;
        }
        return  oldDataValue;
    },
        /**
     *初始化警戒线
        *  */
    warnLine: function () {
        this.warnLineObj = new Array();
        var thisObj = this;
        //24、48小时警戒线---1 )need points,colors,line style
        var points_24h =[[126.993568, 34.005024], [126.993568 ,21.971252 ], [118.995521,17.96586], [118.995521,10.97105], [113.018959,4.48627], [104.998939,-0.035506]];
            //[[127, 34], [127, 22], [110, 15]];
        var color_24h ='#FFFF00';  //{r: 255, g: 255, b: 0};
        var points_48h = [[131.981361, 33.959474], [131.981361 ,14.96886 ], [119.962318,-0.035506], [104.998939,-0.035506]];
        //[[132, 34], [132, 22], [125, 15], [110, 15]];
        var color_48h = '#160DFF'; //{r: 22, g: 13, b: 255};
        var lineStyle24h=undefined;
        var lineStyle48h=undefined;

        points_24h=this.getValidDataValue(points_24h,thisObj.warning_line_parm.points_24h);
        color_24h=this.getValidDataValue(color_24h,thisObj.warning_line_parm.color_24h);
        color_48h=this.getValidDataValue(color_48h,thisObj.warning_line_parm.color_48h);
        points_48h=this.getValidDataValue(points_48h,thisObj.warning_line_parm.points_48h);
        lineStyle24h=this.getValidDataValue(lineStyle24h,thisObj.warning_line_parm.lineStyle24h);
        lineStyle48h=this.getValidDataValue(lineStyle48h,thisObj.warning_line_parm.lineStyle48h);

        this.addLine(this.warnLinelayer, points_24h, color_24h,lineStyle24h);
        this.addLine(this.warnLinelayer, points_48h, color_48h,lineStyle48h);

        var addPicture = function (layer, point, pic) {
            var symbol = new g2.sfs.PictureMarkerSymbol({
                source: pic,
                width: "28",
                height: "144",
                rotation: "0",
                opacity: "1",
                offsetX: "13",
                offsetY: "31"
            });
            var point = new g2.sfs.Point({
                x: point[0],
                y: point[1],
                spatialReference: thisObj.dataSpatialReference
                //spatialReference: thisObj.map.spatialReference
            });
            point=thisObj._transformMap(point);
            var ele = new g2.sfs.Element({geometry: point, symbol: symbol});
            layer.add(ele);
        };
        var pic24_xy=[127,30];
        var pic48_xy=[132,30];
        pic24_xy=thisObj.warning_line_parm.pic24_xy;
        pic48_xy=thisObj.warning_line_parm.pic48_xy;
        addPicture(this.warnLinelayer, pic24_xy, thisObj.warning_line_parm.pic_base24);
        addPicture(this.warnLinelayer, pic48_xy, thisObj.warning_line_parm.pic_base48);
    },
    /**
     * 增加警戒线
     * @param layer  图层对象
     * @param points 点数组
     * @param rgb  颜色值
     * @param linestyle 线样式
     */
    addLine : function (layer, points, rgb,linestyle) {
        var thisObj = this;
        //构造线发符号实例和线实例
        var color1=new g2.sfs.Color.fromHex(rgb)
        color1.a=153;
        var ploylineSymbol = new g2.sfs.SimpleLineSymbol({
            color: color1
        });
        if (linestyle!=undefined){
            ploylineSymbol.style=linestyle;
        }
        var polyline = new g2.sfs.Polyline({spatialReference: thisObj.map.spatialReference});
        //构造path实例
        var path = new g2.sfs.Path({spatialReference: thisObj.map.spatialReference});
        //构造线上的角点
        for (var i = 0; i < points.length; i++) {
            var point = new g2.sfs.Point({
                x: points[i][0],
                y: points[i][1],
                spatialReference: thisObj.dataSpatialReference
                //spatialReference: thisObj.map.spatialReference
            });
            //将点加入path中
            path.addPoint(point);
        }
        //将path加入polyline中
        polyline.addGeometry(path);
        polyline=thisObj._transformMap(polyline);
        //构造element实例
        var polylineElement = new g2.sfs.Element({geometry: polyline, symbol: ploylineSymbol});
        //将element加入到图层中
        layer.add(polylineElement);
    },
    //卸载组件
    unload:function (){
        ComponentBase.prototype.unload.call(this);
        if (this.enable==false)return;
        this._removeLayer(this.warning_line_parm.id);

    },
    //删除图层
    _removeLayer:function(layerId){
        var layer=this.map.findLayer(layerId);
        do {
            this.map.removeLayer(layer);
            layer=this.map.findLayer(layerId);
        } while(layer!=undefined)
    },
        //参数合并
    _mergeOptions:function(dest){
        var i,j,len,src;
        for (var j=1,len=arguments.length;j<len;j++){
            src=arguments[j];
            for (i in src){
                dest[i]=src[i]
            }
        }
        return dest
    },
    //转换成地图缺省坐标
    _transformMap:function(oldGeo){
        if (this.dataSpatialReference==this.map.spatialReference) {return oldGeo};
        var pro =new g2.sfs.CoordinateTransform();
        var pp=pro.transform(oldGeo,this.map.spatialReference);
        return pp ;
    },

});
module.exports= component;
